import { defineStore } from "pinia";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import router from '@/router'


const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5000/api";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("user")) || null,
    rol: localStorage.getItem("rol") || null,
    token: localStorage.getItem("token") || null,
    loadingRegister: false,
    updatingProfile: false,
  }),
  getters: {
    isTokenExpired(state) {
      if (!state.token) return true;

      try {
        const decoded = jwtDecode(state.token);
        const currentTime = Math.floor(Date.now() / 1000);
        return decoded.exp && decoded.exp < currentTime;
      } catch (e) {
        return true; // Si no se puede decodificar, lo tratamos como inválido
      }
    },
  },
  actions: {
    setUserAndToken(userData) {

      this.user = userData.user;
      this.rol = userData.rol;
      this.token = userData.access_token;

      localStorage.setItem("user", JSON.stringify(this.user));
      localStorage.setItem("rol", this.rol);
      localStorage.setItem("token", this.token);
    },
    setUser(user) {
      this.user = user;
      localStorage.setItem("user", JSON.stringify(this.user));
    },
    clearAuthData() {
      this.user = null;
      this.rol = null;
      this.token = null;

      localStorage.removeItem("user");
      localStorage.removeItem("rol");
      localStorage.removeItem("token");
    },
    checkTokenAndLogoutIfExpired() {
      if (this.isTokenExpired) {
        this.clearAuthData();
        router.push('/');
      }
    },
    async registerUser(data) {
      try {
        this.loadingRegister = true;

        // Registro normal
        const response = await axios.post(`${API_URL}/auth/register`, data);

        // Añadir contacto a Brevo (esperando la respuesta)
        try {
          const brevoResponse = await fetch(`${API_URL}/auth/send-brevo-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: data.email, nombre: data.username })
          });

          const brevoData = await brevoResponse.json();

          if (brevoData.success) {
            console.log('brevo_contact_added');
          } else {
            console.error('brevo_contact_error', brevoData.error);
          }
          this.loadingRegister = false;

        } catch (brevoError) {
          console.error('brevo_fetch_error', brevoError);
          this.loadingRegister = false;
        }

        return response.data;
      } catch (error) {
        this.loadingRegister = false;
        if (error.response) {
          const errorCode = error.response.data.code || error.response.status;
          const message = error.response.data.message || 'unknown_error';
          throw { code: errorCode, message };
        } else {
          throw { code: "NETWORK_ERROR", message: 'connection_error' };
        }
      }
    },
    async updateProfile(endpoint, id, data, token) {
      try {
        this.updatingProfile = true;
        const response = await axios.put(`${API_URL}/${endpoint}/${id}`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        this.updatingProfile = false;
        return response.data;
      } catch (error) {
        if (error.response) {
          const errorCode = error.response.data.code || error.response.status;
          const message =
            error.response.data.message || "Error al actualizar el perfil.";
          this.updatingProfile = false;
          throw { code: errorCode, message };
        } else {
          this.updatingProfile = false;
          throw { code: "NETWORK_ERROR", message: "Error de conexión." };
        }
      }
    },
    async googleRegister(data) {
      try {
        const response = await axios.post(`${API_URL}/auth/google-register`, data);

        // Añadir contacto a Brevo (esperando la respuesta)
        try {
          const brevoResponse = await fetch(`${API_URL}/auth/send-brevo-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: data.email, nombre: data.username })
          });

          const brevoData = await brevoResponse.json();

          if (brevoData.success) {
            console.log('brevo_contact_added');
          } else {
            console.error('brevo_contact_error', brevoData.error);
          }
          this.loadingRegister = false;

        } catch (brevoError) {
          console.error('brevo_fetch_error', brevoError);
          this.loadingRegister = false;
        }
        
        return response.data;
      } catch (error) {
        if (error.response) {
          // Protegemos por si no existe .code en data
          const errorCode = error.response.data.code || error.response.status;
          const message = error.response.data.message || "Error desconocido.";

          throw { code: errorCode, message };
        } else {
          throw { code: "NETWORK_ERROR", message: "Error de conexión." };
        }
      }
    }
  },
});
